// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"e3330692","166":"7f7fe40b","439":"6fecf5f1"}[chunkId] + ".chunk.css";
};